module.exports = __webpack_public_path__ + "static/img/pisanki.09f476b0.webp";